import { FC } from "react";
import { Box, Button, Typography, Modal } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { customToast } from "hooks/toast";
import { PdfRenderTable } from "componentsNew/tables/PdfTable/ShiftTracker/PdfRenderTable";
import GetAppIcon from "@material-ui/icons/GetApp";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useDispatch } from "react-redux";
import { closeModal } from "actions/modalActions";

interface PdfGenerationModalProps {}

export const PdfGenerationModal: FC<PdfGenerationModalProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { modalName } = useTypeSelectors((state) => state.modalState);
  const { currentReportStation, currentReportDate } = useTypeSelectors((state) => state.dasBoard);

  const onClose = () => dispatch(closeModal());
  const handleDownloadPdf = () => {
    customToast("loading", "Generating PDF...");
    const data = document.getElementById("tablePdf");
    if (data)
      html2canvas(data)
        .then((canvas) => {
          const contentDataURL = canvas.toDataURL("image/png");
          let margin = 0;
          let imgWidth = 210;
          let pageHeight = 295;
          let imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let doc = new jsPDF("p", "mm");
          let position = 0;

          doc.addImage(
            contentDataURL,
            "PNG",
            margin,
            position,
            imgWidth,
            imgHeight,
            "someAlias",
            "FAST",
          );

          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              contentDataURL,
              "PNG",
              margin,
              position,
              imgWidth,
              imgHeight,
              "someAlias",
              "FAST",
            );
            heightLeft -= pageHeight;
          }
          doc.save(`DA Tracker ${currentReportStation.title} ${moment(currentReportDate).format("DD MMM yyyy")}.pdf`);
        })
        .catch(() => {
          customToast("error", "Something was wrong!");
        });
  };

  const handleSubmit = () => {
    handleDownloadPdf();
    onClose();
  };

  return (
      <Modal open={modalName === "download-pdf-modal"} onClose={onClose}>
        <Box className={classes.modalBox}>
          <Box className={classes.modalTitle}>
            <Typography variant="h3">Table preview</Typography>
            <Button onClick={handleSubmit}>
              <GetAppIcon />
            </Button>
          </Box>
          <PdfRenderTable />
        </Box>
      </Modal>
  );
};

const useStyles = makeStyles((theme) => ({
  modalBox: {
    background: "white",
    display: "flex",
    flexDirection: "column",
    width: "950px",
    position: "absolute",
    left: "20%",
    overflowY: "scroll",

    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.background.default,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.light,
      borderRadius: "5px",
    },
  },
  modalTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: 700,
    justifyContent: "center",
    borderBottom: `1px solid ${theme.palette.primary.light}`,
  },
  button: {
    textTransform: "none",
  },
}));
